const amplifyAuthConfig = {
  Auth: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_SpMZaSqje',
    userPoolWebClientId: '4nn1goool24rhgr3ftcvn4g2hh',
    mandatorySignIn: true,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    storage: sessionStorage,
  },
};

export default amplifyAuthConfig;
